export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  content: string;
  tags: string[];
  author: string;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "2026秋冬日系穿搭指南：层次感是关键词",
    excerpt: "日系穿搭的精髓在于层次感的营造。从基础款到点睛配饰，我们为你解析本季最值得关注的日系潮流元素，让你轻松驾驭日系风格。",
    category: "日系",
    date: "2026-07-28",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Japanese%20fall%20winter%20layered%20fashion%20outfit%20inspiration%2C%20neutral%20warm%20tones%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-detail-1&orientation=landscape",
    content: `日系穿搭的魅力，在于它看似随性实则用心的层次感营造。2026年秋冬季，日系风格在延续经典的同时，融入了更多现代元素。本文将从多个维度为你解析本季日系穿搭的核心法则。

## 层次感的艺术

日系穿搭最核心的关键词就是"层次感"。通过不同材质、不同长度的单品叠加，创造出丰富的视觉层次。比如一件轻薄的针织开衫外搭宽松风衣，内里再叠一件高领打底，三层叠加既保暖又有型。

关键在于材质的选择——柔软与挺括的对比、轻盈与厚重的交错，这些对比让整体造型更加生动有趣。棉麻与羊毛、丝绸与牛仔，不同材质的碰撞正是日系穿搭的精髓所在。

## 色彩搭配法则

2026年秋冬季的日系色彩以大地色系为主调，奶油白、燕麦色、焦糖棕、橄榄绿是主流选择。日系穿搭讲究"同色系不同深浅"的搭配方式，用同一色系的深浅变化营造高级感。

比如全身以米白色为基调，用驼色围巾和深棕色包包做点缀，整体和谐又不失层次。这种配色方式不仅显高级，还非常显白显气质。

## 廓形的选择

宽松但不臃肿是日系廓形的核心。OVERSIZE外套搭配修身内搭，上宽下窄的搭配法则永远不会出错。宽腿裤搭配修身针织，或者A字长裙搭配短款外套，都是日系穿搭的经典公式。

## 配饰点睛

日系穿搭中配饰的分量不可忽视。一顶贝雷帽、一条丝巾、一只帆布托特包，这些细节往往决定了整体造型的完成度。选择配饰时注意与整体色调的呼应，点到即止不过度堆砌。

## 总结

日系穿搭看似简单，实则考验搭配功力。掌握层次感、色彩、廓形和配饰这四个维度，你也能轻松打造出令人眼前一亮的日系风格造型。记住，日系穿搭的精髓在于"不经意间的精致"——看起来毫不费力，实则处处用心。`,
    tags: ["日系穿搭", "秋冬潮流", "层次感", "色彩搭配", "配饰推荐"],
    author: "潮流编辑部",
  },
  {
    id: "article-2",
    title: "韩系偶像风穿搭秘诀：从舞台到日常",
    excerpt: "韩国偶像的穿搭一直是潮流风向标。本文拆解韩系偶像穿搭的精髓，教你把舞台造型转化为日常可穿的时尚搭配。",
    category: "韩系",
    date: "2026-07-22",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Korean%20idol%20inspired%20casual%20fashion%20outfit%2C%20modern%20urban%20style%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-detail-2&orientation=landscape",
    content: `韩国偶像的舞台造型总是光鲜亮丽，但她们的私服穿搭同样精彩。韩系穿搭之所以风靡亚洲，正是因为它在时尚感和实穿性之间找到了完美平衡。来看看如何把偶像穿搭落地到日常。

## 舞台到日常的转化法则

偶像舞台造型通常比较夸张——亮片、皮草、超大配饰。但转化为日常穿搭时，我们只需要提取核心元素。比如把亮片连衣裙换成缎面半裙，把夸张耳饰换成小巧的金属耳钉。

关键在于保留舞台造型的"氛围感"——利落的剪裁、高级的配色、恰到好处的露肤度，这些元素才是韩系穿搭的灵魂。

## 必备单品解析

韩系穿搭的衣橱基石其实很简单：一件廓形西装外套、一条高腰直筒裤、一件短款针织衫。这三件单品几乎可以组合出80%的韩系日常造型。

廓形西装外套搭配牛仔裤是经典韩式休闲风，搭配同色西裤则是精致通勤风。短款针织搭配高腰下装，轻松打造三七分黄金比例。

## 配色哲学

韩系穿搭偏爱中性色调——奶油白、燕麦色、炭灰色、藏青色。整体配色通常不超过三个颜色，以简洁取胜。偶尔用一件亮色单品打破沉闷，比如一只红色链条包或一双亮色运动鞋。

## 配饰的魔力

韩国博主们深谙配饰的力量。一顶棒球帽、一条细腰带、一只迷你链条包，这些小物件往往能让基础款焕发新生。韩系配饰的特点是精致小巧，不会喧宾夺主但恰到好处。

## 总结

韩系穿搭的门槛其实不高，掌握核心单品和配色法则，每个人都能穿出韩系博主的既视感。关键在于自信——韩系风格传递的正是这种"我很时尚但我没用力"的从容态度。`,
    tags: ["韩系穿搭", "偶像风", "日常搭配", "配色法则", "配饰技巧"],
    author: "潮流编辑部",
  },
  {
    id: "article-3",
    title: "欧美极简主义：少即是多的穿搭哲学",
    excerpt: "欧美极简风格正在重塑时尚界。从Capsule Wardrobe到高质量基础款，我们带你深入了解欧美极简穿搭的核心法则。",
    category: "欧美",
    date: "2026-07-18",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=European%20minimalist%20capsule%20wardrobe%20aesthetic%2C%20neutral%20beige%20and%20cream%20tones%2C%20clean%20studio%20photography%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20aesthetic&width=1200&height=630&seq=article-detail-3&orientation=landscape",
    content: `在快时尚席卷全球的时代，欧美极简主义穿搭如一股清流。它倡导的"少即是多"理念，不仅是一种穿搭方式，更是一种生活态度。一起来了解极简穿搭的核心哲学。

## 什么是胶囊衣橱

胶囊衣橱（Capsule Wardrobe）是极简穿搭的核心概念。它的理念是用有限的高质量基础款，组合出无限的搭配可能。一个典型的胶囊衣橱通常包含30-40件单品，涵盖上衣、下装、外套、鞋履和配饰。

关键是每件单品都经过精心挑选，版型、面料、颜色都经得起时间考验。这些单品之间可以自由组合，大大减少了"衣柜里有很多衣服但不知道穿什么"的烦恼。

## 基础款的挑选标准

极简穿搭的基础款不是随便的白T恤和黑裤子。挑选基础款有三个标准：面料的品质感、版型的完美度、色彩的包容性。

一件好的白T恤，面料应该挺括有质感而不是薄透松垮。一条好的黑裤子，版型应该修饰身材而不是暴露缺点。当你把基础款的品质感拉满，即使是最简单的搭配也充满高级感。

## 配色方案

极简穿搭的配色通常围绕中性色展开——白色、米色、驼色、灰色、黑色、藏青色。这些颜色之间高度兼容，任何两件单品拿出来都能搭在一起。

偶尔可以加入一件低饱和度的彩色单品作为点缀，比如雾霾蓝衬衫或橄榄绿针织，但整体依然保持简洁克制的调性。

## 投资单品的智慧

极简穿搭鼓励"少买但买好"。与其买十件快时尚单品，不如投资一件经典羊绒大衣或一只真皮手袋。这些高品质单品不仅穿着体验更好，长远来看性价比也更高。

## 总结

极简穿搭不是无趣，而是把注意力从"穿什么"转移到"怎么穿"。当你不再被眼花缭乱的潮流牵着走，反而能更清晰地找到属于自己的风格。这就是极简穿搭的真正魅力。`,
    tags: ["极简主义", "胶囊衣橱", "基础款", "欧美风格", "穿搭哲学"],
    author: "潮流编辑部",
  },
  {
    id: "article-4",
    title: "2026春夏韩系色彩趋势：柔和的马卡龙色系",
    excerpt: "2026年春夏，韩系穿搭迎来了一波温柔的马卡龙色系热潮。从薰衣草紫到薄荷绿，这些低饱和度的梦幻色彩正在席卷韩国街头。",
    category: "韩系",
    date: "2026-07-15",
    readTime: "5分钟",
    image: "https://readdy.ai/api/search-image?query=Korean%20pastel%20macaron%20color%20fashion%20trend%2C%20soft%20lavender%20and%20mint%20tones%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-detail-4&orientation=landscape",
    content: `告别沉闷的深色系，2026年春夏韩系穿搭迎来了一波温柔到冒泡的马卡龙色系热潮。薰衣草紫、薄荷绿、蜜桃粉、奶油黄……这些低饱和度的梦幻色彩正席卷韩国街头。

## 马卡龙色系的魅力

与传统的亮色不同，马卡龙色系的特点是低饱和度、高明度。这意味着它们既鲜艳又不刺眼，既有存在感又不夸张。这种微妙的平衡正是韩系穿搭的精髓。

马卡龙色系还有一个巨大优势——非常显白。无论你是冷白皮还是暖黄皮，总有一款马卡龙色能让你的肤色看起来更通透。

## 如何驾驭马卡龙色

对于初次尝试马卡龙色的朋友，建议从一件单品开始。比如一件薰衣草紫的针织开衫或一双薄荷绿的运动鞋，用中性色单品来搭配它们，让马卡龙色成为整体造型的亮点而不是主角。

进阶玩家可以尝试同色系搭配——不同深浅的紫色叠穿在一起，营造出梦幻的渐变效果。或者大胆地将不同马卡龙色混搭，打造出独特的个性风格。

## 推荐配色组合

薰衣草紫 + 奶油白：温柔知性，适合职场和约会
薄荷绿 + 燕麦色：清新自然，春日气息满分
蜜桃粉 + 浅牛仔蓝：甜美减龄，少女感十足
奶油黄 + 白色：明亮温暖，阳光活力

## 总结

马卡龙色系是2026春夏不可错过的趋势。它温柔、高级、显白，完美契合韩系穿搭的审美追求。这个春夏，不妨让衣橱多一些温柔色彩。`,
    tags: ["韩系", "色彩趋势", "马卡龙色", "春夏穿搭", "显白搭配"],
    author: "潮流编辑部",
  },
  {
    id: "article-5",
    title: "日系森女风：回归自然的穿搭美学",
    excerpt: "森女风（Mori Girl）作为日系穿搭的重要分支，以其自然、舒适、文艺的特质持续吸引着追求慢生活的都市女性。",
    category: "日系",
    date: "2026-07-10",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Japanese%20mori%20girl%20natural%20earthy%20fashion%20style%2C%20linen%20and%20cotton%20textures%2C%20minimalist%20photography%2C%20cream%20backdrop%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-detail-5&orientation=landscape",
    content: `在快节奏的都市生活中，森女风（Mori Girl）以其自然、舒适、文艺的特质，为追求慢生活的人们提供了一种穿搭上的精神出口。

## 森女风的起源与定义

森女风起源于日本，字面意思是"仿佛从森林中走出来的女孩"。它强调天然材质、宽松廓形和层次叠穿，整体风格温暖、柔和、带有淡淡的复古文艺气息。

森女风不仅仅是一种穿搭风格，更代表了一种生活态度——追求自然、享受慢生活、注重内心的平静与满足。

## 森女风的核心单品

打造森女风造型，衣橱里需要这几件核心单品：棉麻连衣裙、宽松针织开衫、复古碎花衬衫、A字半身长裙、厚底圆头鞋。这些单品的共同特点是材质天然、版型宽松、色彩温暖。

棉麻是森女风最重要的面料，它的自然肌理和透气特性完美契合森女风追求的自然质感。一件棉麻连衣裙外搭针织开衫，就是最经典的森女造型。

## 色彩与图案

森女风的色彩以大地色系和暖色调为主——米白、驼色、橄榄绿、砖红、姜黄。图案方面，碎花、格纹、波点都是经典选择，但要注意图案不宜过大或过于鲜艳。

## 配饰选择

森女风的配饰同样强调自然材质——木质饰品、编织包袋、棉麻围巾、毛线帽。这些配饰为整体造型增添了温暖的手工感，让穿搭更加完整。

## 总结

森女风是日系穿搭中最具治愈感的分支。它用天然的材质和柔和的色彩，为穿着者打造出舒适自在的个人空间。如果你想尝试一种不被潮流裹挟的穿搭方式，森女风会是一个美好的选择。`,
    tags: ["森女风", "日系", "自然风格", "棉麻穿搭", "文艺风格"],
    author: "潮流编辑部",
  },
  {
    id: "article-6",
    title: "美式复古风潮：90年代穿搭全面回归",
    excerpt: "从牛仔裤到格纹衬衫，从棒球帽到马丁靴，90年代的美式复古风格正在全面回归时尚舞台。",
    category: "美式",
    date: "2026-07-05",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=American%2090s%20retro%20vintage%20fashion%20style%2C%20denim%20and%20flannel%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-detail-6&orientation=landscape",
    content: `时尚是一个轮回，90年代的美式复古风格正在以全新的方式回归。宽松牛仔裤、格纹衬衫、棒球帽、马丁靴……这些曾经风靡一时的单品，如今又成为了潮流焦点。

## 90年代美式风格的核心

90年代美式风格的关键词是：随性、不羁、实用。它不像法式那样讲究精致，也不像日系那样追求层次，而是以一种毫不费力的方式展现个性。

这种风格深受音乐和街头文化的影响——Grunge摇滚、Hip-Hop、滑板文化，都为90年代美式穿搭注入了独特的态度。破洞牛仔裤、乐队T恤、法兰绒格纹衬衫，这些都是那个时代的标志性符号。

## 经典单品回归

本季最值得关注的复古单品包括：

高腰直筒牛仔裤：告别紧身款，宽松直筒版型回归主流，搭配运动鞋或马丁靴都很好看。

棒球夹克：学院风字母刺绣搭配经典配色，复古又时髦，是秋冬造型的点睛之笔。

厚底马丁靴：经典8孔设计搭配加厚鞋底，酷感十足又显腿长。

格纹衬衫：法兰绒材质搭配经典红黑格纹，可单穿也可当外套叠穿。

## 现代演绎方式

完全照搬90年代的穿搭可能会显得过时。现代演绎的关键在于混搭——用一件复古单品搭配摩登单品。比如用复古牛仔裤搭配简约针织衫，或者用棒球夹克搭配连衣裙。

配饰也很重要。一顶棒球帽、一条皮质编织腰带、一双白色运动袜，这些小细节能让复古造型更有现代感。

## 总结

美式复古风格的魅力在于它的包容性和自由感。不需要刻意追求精致完美，随性自然的穿搭态度本身就是最好的时尚表达。这个秋冬，不妨让衣橱多一些90年代的复古气息。`,
    tags: ["美式复古", "90年代", "牛仔裤", "棒球夹克", "格纹衬衫"],
    author: "潮流编辑部",
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getRelatedArticles = (currentId: string, category: string, limit: number = 3): Article[] => {
  return articles
    .filter((article) => article.id !== currentId && article.category === category)
    .slice(0, limit);
};